import React from 'react';
import PropTypes from 'prop-types';
import {
  ErrorPage,
  ErrorCard,
  IconCircle,
  TextGroup,
  RetryButton,
} from './PageErrorState.styles';

function PageError({
  title = 'Something went wrong',
  description = 'We were unable to load this information. Please try again.',
  buttonText = 'Try Again',
}) {
  return (
    <ErrorPage>
      <ErrorCard>
        <IconCircle>!</IconCircle>

        <TextGroup>
          <h2>{title}</h2>
          {description && <p>{description}</p>}
        </TextGroup>

        <RetryButton type="button" onClick={() => window.location.reload()}>
          {buttonText}
        </RetryButton>
      </ErrorCard>
    </ErrorPage>
  );
}

export default PageError;

PageError.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  buttonText: PropTypes.string,
};
